// React
import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

// Components
import { ModalCartPicker } from 'store/modules/cart/CartPicker/Modal'

// Hooks
import { useDatePicker } from 'store/hooks/useDatePicker'

// Shared
import ClientActions from 'store/v2/redux/actions/client'
import { useOrm } from 'shared/utils/useOrm'

export const CartPicker = () => {
  const { isOpen, close } = useDatePicker()

  const cartId = useSelector((state) => state.client.cartId)
  const cart = useOrm('carts', (carts) => carts.getById(cartId || window.booqableOptions.cart?.id))
  const behavior = useSelector((state) => state.settings.get('store.behaviors.add_button'))

  const cartHasLines = useMemo(() => cart?.lines && cart.lines.length > 0, [cart])

  const onSave = useCallback(() => {
    if (behavior === 'checkout' && !ClientActions.evaluateCartOverdue() && cartHasLines) {
      ClientActions.setCheckingOut()
    }
  })

  if (!cart) return null

  return <ModalCartPicker open={isOpen} onClose={close} onSave={onSave} />
}
